import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import MediciService from "../../../../../services/MediciService";
import Utils from "../../../../../utils/Utils";
import Button from "../../../../../components/button/Button";
import stylesWelcome from "../DatiSegnalazioneAnagrafici.module.css";
import styles from "../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Input from "../../../../../components/textbox/Input";
import Table from "../../../../../components/table/Table";
import $ from "jquery";
import ToasterSingleton from "../../../../../singleton/ToasterSingleton";
import toasterConfig from "../../../../../config/toasterConfig";
import OggettiUtili from "../../../../../utils/OggettiUtili.json";

class DatiAnagraficiMedico extends Component {
    state = {
        datiMedico: {
            idMedico: "",
            nome: "",
            cognome: "",
            ruolo: "",
            recapitoTelefonico: "",
            fax: "",
            email: "",
            medicoAnagrafe: "",
        },
        disabledCercaMedico: true,
        formMedicoSpecifico: true,
        rowsTabMedico: [],
        totalElementsTabMedico: 0,
        showTableMedico: false,
        malattieConSchedaSpeciale: OggettiUtili.malattieConSchedaSpeciale,
        disabledPulisciCampi: false,
        ruoloNull: true,
    };
    colsTabMedico = [
        {key: "checkedMedico", name: "", tipo: "checkbox", isRadio: true},
        {key: "cognomeNome", name: "Cognome e Nome"},
        {key: "ruolo", name: "Ruolo", sortDirection: "none"},
    ];

    constructor(props) {
        super(props);
        this.props.setDatiMedico(this.state.datiMedico);
        this.props.setDatiMedicoCopia(this.state.datiMedicoCopia);
        if (this.props.inserimentoManuale) {
            this.state.formMedicoSpecifico = true;
        }
        this.sendRequestMedico = this.sendRequestMedico.bind(this);
        this.selezionaMedico = this.selezionaMedico.bind(this);
        this.pulisciCampiMedico = this.pulisciCampiMedico.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiungiMedico = this.aggiungiMedico.bind(this);
        this.letturaMedico = this.letturaMedico.bind(this);
        this._validate = this._validate.bind(this);
        this.controlloModificaCampi = this.controlloModificaCampi.bind(this);
    }

    componentDidMount() {
        if (
            !Utils.isEmpty(this.props.segnalazione) &&
            this.props.segnalazione.medicoId
        ) {
            this.letturaMedico(this.props.segnalazione.medicoId);
        } else {
            let medicoAttuale = this.state.datiMedico;
            if (
                this.props.datiMedico &&
                (this.props.datiMedico.nome ||
                    this.props.datiMedico.cognome ||
                    this.props.datiMedico.ruolo)
            ) {
                medicoAttuale.nome = this.props.datiMedico.nome;
                medicoAttuale.cognome = this.props.datiMedico.cognome;
                medicoAttuale.ruolo = this.props.datiMedico.ruolo;
            }
            this.setState({datiMedico: medicoAttuale});
        }
        this.controlloModificaCampi();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.segnalazione !== this.props.segnalazione) {
            if (
                !Utils.isEmpty(this.props.segnalazione) &&
                this.props.segnalazione.medicoId
            ) {
                this.letturaMedico(this.props.segnalazione.medicoId);
            }
            this.controlloModificaCampi();
        }
    }

    controlloModificaCampi() {
        let disabledPulisciCampi = Utils.controlloModificaCampi(
            this.props.segnalazione
        );
        if (disabledPulisciCampi) {
            this.setState({disabledPulisciCampi: disabledPulisciCampi});
        }
    }

    letturaMedico(idMedico) {
        let newRuoloNull = true;
        MediciService.getMedicoById(idMedico)
            .then((data) => {
                let datiMedico = JSON.parse(JSON.stringify(data.data));
                let datiMedicoCopia = JSON.parse(JSON.stringify(data.data));
                if (datiMedico.ruolo === null) {
                    newRuoloNull = false;
                }
                this.setState({
                    datiMedico: datiMedico,
                    datiMedicoCopia: datiMedicoCopia,
                    formMedicoSpecifico: false,
                    ruoloNull: newRuoloNull,
                });
                this.props.setDatiMedico(this.state.datiMedico);
                this.props.setDatiMedicoCopia(this.state.datiMedicoCopia);
                $(".selectpicker").selectpicker("render");
            })
            .catch((reason) => {
                console.log("[ERROR] get lettura medico: " + reason);
            });
    }

    pulisciCampiMedico() {
        let datiMedico = {
            nome: "",
            cognome: "",
            ruolo: "",
            recapitoTelefonico: "",
            fax: "",
            email: "",
            medicoAnagrafe: "",
        };
        this.setState(
            {
                datiMedico: datiMedico,
                showTableMedico: false,
                formMedicoSpecifico: true,
            },
            () => this.props.setDatiMedico(this.state.datiMedico)
        );
    }

    riceviValore(field, event) {
        let datiMedico = this.state.datiMedico;
        datiMedico[field] = event.target.value;
        this.setState({
            datiMedico: datiMedico,
            disabledCercaMedico: this.disabilitaCercaMedico(),
        });
        this.props.setDatiMedico(datiMedico);
    }

    _validate() {
        if (
            (this.state.datiMedico.nome &&
                this.state.datiMedico.nome.length < 2) ||
            (this.state.datiMedico.cognome &&
                this.state.datiMedico.cognome.length < 2)
        ) {
            return this.aggiungiToaster(["Messages.ERR_01_01_0B_0U"]);
        }
        if ((this.state.datiMedico.cognome && (this.state.datiMedico.cognome.startsWith(" ") || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.cognome))))) {
            return this.aggiungiToaster(["Messages.cognome_medico"]);
        }
        if (this.state.datiMedico.nome && (this.state.datiMedico.nome.startsWith(" ") || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.nome)))) {
            return this.aggiungiToaster(["Messages.nome_medico"]);
        }
        if ((this.state.datiMedico.ruolo && (this.state.datiMedico.ruolo.startsWith(" ") || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.ruolo))))) {
            return this.aggiungiToaster(["Messages.ruolo_medico"]);
        }
        this.sendRequestMedico();
    }

    disabilitaCercaMedico() {
        let flag = false;
        if (
            this.state.datiMedico.nome === "" ||
            this.state.datiMedico.cognome === "" ||
            this.state.datiMedico.cognome.startsWith(" ") ||
            this.state.datiMedico.nome.startsWith(" ")
        )
            flag = true;
        return flag;
    }

    sendRequestMedico() {
        let params = {};
        if (this.state.datiMedico.nome) {
            if (
                this.state.datiMedico.nome.startsWith(" ") ||
                this.state.datiMedico.nome.endsWith(" ")
            ) {
                params["nome"] = this.state.datiMedico.nome.trim();
            } else {
                params["nome"] = this.state.datiMedico.nome;
            }
        }

        if (this.state.datiMedico.cognome) {
            if (
                this.state.datiMedico.cognome.startsWith(" ") ||
                this.state.datiMedico.cognome.endsWith(" ")
            ) {
                params["cognome"] = this.state.datiMedico.cognome.trim();
            } else {
                params["cognome"] = this.state.datiMedico.cognome;
            }
        }
        if (this.state.datiMedico.ruolo) {
            params["ruolo"] = this.state.datiMedico.ruolo;
        }
        MediciService.getMedici(params)
            .then((data) => {
                if (data.data.length > 0) {
                    let res = Utils.mapGetMedico(data);
                    this.setState({
                        rowsTabMedico: res,
                        showTableMedico: true,
                        totalElementsTabMedico: res.length,
                    });
                } else {
                    this.setState({
                        showTableMedico: false,
                        rowsTabMedico: [],
                        formMedicoSpecifico: false,
                    });
                }
            })
            .catch(() => {
                this.setState({
                    showTableMedico: true,
                    rowsTabMedico: [],
                    formMedicoSpecifico: false,
                });
            });
    }

    selezionaMedico(row, isChecked) {
        let ruoloNull = false;
        this.props.setDatiMedico(Utils.mapGetMedicoPerForm(row));
        this.props.setDatiMedicoCopia(Utils.mapGetMedicoPerForm(row));
        if (row.ruolo !== null) {
            ruoloNull = true;
        }
        this.setState({
            formMedicoSpecifico: !isChecked,
            datiMedico: Utils.mapGetMedicoPerForm(row),
            showTableMedico: false,
            ruoloNull: ruoloNull,
        });
    }

    aggiungiMedico() {
        this.setState({
            showTableMedico: false,
            rowsTabMedico: [],
            formMedicoSpecifico: false,
        });
    }

    aggiungiToaster(text, tipo) {
        ToasterSingleton.instance().aggiuntaToaster({
            type:
                tipo && tipo === 1
                    ? toasterConfig.types.successo
                    : toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
        });
    }

    render() {
        const {t} = this.props;
        const datiMedico = (
            <div>
                <div style={{marginTop: "2rem"}}>
                    <div className={"row"}>
                        <div className="col-lg-4">
                            <h6 style={{marginTop: "1rem"}}>
                                {t(
                                    "DatiSegnalazioneAnagrafici.Dati_relativi_al_Medico_Segnalatore"
                                )}
                            </h6>
                        </div>
                        <div className="col-lg-8">
                            <Button
                                id={"pulisciCampi"}
                                text={"Pulisci campi"}
                                onClick={this.pulisciCampiMedico}
                                style={{
                                    display: this.state.formMedicoSpecifico
                                        ? "none"
                                        : "",
                                    height: "2rem",
                                    marginTop: "1rem",
                                    float: "right",
                                }}
                                className={"btnWhite col-lg-3"}
                                disabled={this.state.disabledPulisciCampi}
                            ></Button>
                        </div>
                    </div>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container">
                    <div className="row">
                        <div className={`col-lg-4 col-sm-12 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                style={{marginRight: "20px"}}
                            >
                                <p
                                    className={styles.labelHeader}
                                    style={{color: "#1b7ea9"}}
                                >
                                    {t("DatiSegnalazioneAnagrafici.cognome")}
                                    <span className={styles.mandatoryColor}>
                                        *
                                    </span>
                                </p>
                                <Input
                                    id={"idcognome"}
                                    onChange={this.riceviValore}
                                    field={"cognome"}
                                    disabled={
                                        this.state.datiMedico.medicoAnagrafe
                                    }
                                    value={this.state.datiMedico.cognome}
                                    placeholder={t(
                                        "DatiSegnalazioneAnagrafici.cognome"
                                    )}
                                    onValidate={
                                        !Utils.isObjectEmpty(
                                            this.state.datiMedico.cognome
                                        )
                                            ? this.state.datiMedico.cognome.replace(
                                                / +/g,
                                                ""
                                            ).length === 0 ||
                                            this.state.datiMedico.cognome.startsWith(
                                                " "
                                            ) || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.cognome))
                                                ? 1
                                                : 2
                                            : 0
                                    }
                                    errorMessage={"cognome non valido"}
                                    maxLength={40}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-4 col-sm-12 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                style={{marginRight: "20px"}}
                            >
                                <p
                                    className={styles.labelHeader}
                                    style={{color: "#1b7ea9"}}
                                >
                                    {t("DatiSegnalazioneAnagrafici.nome")}
                                    <span className={styles.mandatoryColor}>
                                        *
                                    </span>
                                </p>
                                <Input
                                    id={"idNome"}
                                    onChange={this.riceviValore}
                                    field={"nome"}
                                    value={this.state.datiMedico.nome}
                                    placeholder={t(
                                        "DatiSegnalazioneAnagrafici.nome"
                                    )}
                                    disabled={
                                        this.state.datiMedico.medicoAnagrafe
                                    }
                                    onValidate={
                                        !Utils.isObjectEmpty(
                                            this.state.datiMedico.nome
                                        )
                                            ? this.state.datiMedico.nome.replace(
                                                / +/g,
                                                ""
                                            ).length === 0 ||
                                            this.state.datiMedico.nome.startsWith(
                                                " "
                                            ) || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.nome))
                                                ? 1
                                                : 2
                                            : 0
                                    }
                                    errorMessage={"nome non valido"}
                                    maxLength={30}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-4 col-sm-12 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                style={{marginRight: "20px"}}
                            >
                                <p
                                    className={styles.labelHeader}
                                    style={{color: "#1b7ea9"}}
                                >
                                    {t("DatiSegnalazioneAnagrafici.Ruolo")}
                                    {this.state.formMedicoSpecifico ? null : (
                                        <span className={styles.mandatoryColor}>
                                            *
                                        </span>
                                    )}
                                </p>
                                <Input
                                    id={"idRuolo"}
                                    onChange={this.riceviValore}
                                    field={"ruolo"}
                                    value={this.state.datiMedico.ruolo}
                                    placeholder={t(
                                        "DatiSegnalazioneAnagrafici.Ruolo"
                                    )}
                                    disabled={
                                        this.state.datiMedico.medicoAnagrafe &&
                                        this.state.ruoloNull
                                    }
                                    onValidate={
                                        !Utils.isObjectEmpty(
                                            this.state.datiMedico.ruolo
                                        )
                                            ? this.state.datiMedico.ruolo.replace(
                                                / +/g,
                                                ""
                                            ).length === 0 ||
                                            this.state.datiMedico.ruolo.startsWith(
                                                " "
                                            ) || !(/^[a-zA-Z\s'àèéìòùÀÈÉÌÒÙ]+$/.test(this.state.datiMedico.ruolo))
                                                ? 1
                                                : 2
                                            : 0
                                    }
                                    errorMessage={"ruolo non valido"}
                                    maxLength={30}
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className="row"
                        style={{
                            display: this.state.formMedicoSpecifico
                                ? "none"
                                : "",
                        }}
                    >
                        <div className={`col-lg-4 col-sm-12 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                style={{marginRight: "20px"}}
                            >
                                <p
                                    className={styles.labelHeader}
                                    style={{color: "#1b7ea9"}}
                                >
                                    {t(
                                        "DatiSegnalazioneAnagrafici.recapitoTelefonico"
                                    )}
                                </p>
                                <Input
                                    id={"idRecapitoTelefonico"}
                                    onChange={this.riceviValore}
                                    field={"recapitoTelefonico"}
                                    value={
                                        this.state.datiMedico.recapitoTelefonico
                                    }
                                    placeholder={t(
                                        "DatiSegnalazioneAnagrafici.recapitoTelefonico"
                                    )}
                                    onValidate={
                                        !Utils.isObjectEmpty(
                                            this.state.datiMedico
                                                .recapitoTelefonico
                                        )
                                            ? this.state.datiMedico.recapitoTelefonico.replace(
                                                / +/g,
                                                ""
                                            ).length === 0 ||
                                            this.state.datiMedico.recapitoTelefonico.startsWith(
                                                " "
                                            )
                                                ? 1
                                                : 2
                                            : 0
                                    }
                                    errorMessage={
                                        "Numero di telefono non valido"
                                    }
                                />
                            </div>
                        </div>
                        <div className={`col-lg-4 col-sm-12 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                style={{marginRight: "20px"}}
                            >
                                <p
                                    className={styles.labelHeader}
                                    style={{color: "#1b7ea9"}}
                                >
                                    {t("DatiSegnalazioneAnagrafici.fax")}
                                </p>
                                <Input
                                    id={"idFax"}
                                    onChange={this.riceviValore}
                                    field={"fax"}
                                    value={this.state.datiMedico.fax}
                                    placeholder={t(
                                        "DatiSegnalazioneAnagrafici.fax"
                                    )}
                                    onValidate={
                                        !Utils.isObjectEmpty(
                                            this.state.datiMedico.fax
                                        )
                                            ? this.state.datiMedico.fax.replace(
                                                / +/g,
                                                ""
                                            ).length === 0 ||
                                            this.state.datiMedico.fax.startsWith(
                                                " "
                                            )
                                                ? 1
                                                : 2
                                            : 0
                                    }
                                    errorMessage={"Fax non valido"}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-4 col-sm-12 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div
                                className={styles.fieldContainer}
                                style={{marginRight: "20px"}}
                            >
                                <p
                                    className={styles.labelHeader}
                                    style={{color: "#1b7ea9"}}
                                >
                                    {t("DatiSegnalazioneAnagrafici.email")}
                                </p>
                                <Input
                                    id={"idEmail"}
                                    onChange={this.riceviValore}
                                    field={"email"}
                                    value={this.state.datiMedico.email}
                                    placeholder={t(
                                        "DatiSegnalazioneAnagrafici.email"
                                    )}
                                    onValidate={
                                        !Utils.isObjectEmpty(
                                            this.state.datiMedico.email
                                        )
                                            ? this.state.datiMedico.email.replace(
                                                / +/g,
                                                ""
                                            ).length === 0 ||
                                            this.state.datiMedico.email.startsWith(
                                                " "
                                            )
                                                ? 1
                                                : 2
                                            : 0
                                    }
                                    errorMessage={"email non valida"}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <Button
                                text={t("Buttons.cercaMedico")}
                                disabled={this.state.disabledCercaMedico}
                                className={"btnWhite col-lg-2 col-sm-12"}
                                style={{
                                    display: this.state.formMedicoSpecifico
                                        ? ""
                                        : "none",
                                    height: "2rem",
                                    marginTop: "1rem",
                                }}
                                onClick={this._validate}
                            >
                                {t("Buttons.cercaMedico")}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );

        const tableMedico = (
            <div className="container mt-3">
                <div
                    className={styles.contenitoreTabella}
                    style={{marginTop: "2px"}}
                >
                    <Table
                        cols={this.colsTabMedico}
                        rows={this.state.rowsTabMedico}
                        title={t("DatiSegnalazioneAnagrafici.listaMedici")}
                        empty={
                            this.state.rowsTabMedico &&
                            this.state.rowsTabMedico.length === 0
                        }
                        emptyMsg="Non ci sono medici associati a queste credenziali"
                        lengthEditable={false}
                        onSelectCheckbox={this.selezionaMedico}
                        totalElements={this.state.totalElementsTabMedico}
                    />
                </div>
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <Button
                            text={t("Buttons.aggiungiMedico")}
                            className={"btnWhite col-lg-2 col-sm-12"}
                            style={{height: "2rem", marginTop: "-30px"}}
                            onClick={this.aggiungiMedico}
                        >
                            {t("Buttons.aggiungiMedico")}
                        </Button>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                {datiMedico}
                {
                    <div>
                        {this.state.showTableMedico ? (
                            <div>{tableMedico}</div>
                        ) : (
                            <div/>
                        )}
                    </div>
                }
            </div>
        );
    }
}

export default withTranslation("common")(DatiAnagraficiMedico);
